export default function roles() {
  return ['level_4', 'level_3', 'level_2', 'level_1'];
}

export function allowAccess(leastRole, keycloak, facility) {
  const { tokenParsed } = keycloak;
  const { roles: userRoles } = tokenParsed.realm_access;
  const { locations } = tokenParsed;

  // Level 1 is the root user.
  if (userRoles.includes([...roles()][3])) {
    return true;
  }

  if (facility && !locations.includes(facility)) {
    return false;
  }

  const indexOfLeastRole = [...roles()].findIndex(role => role === leastRole);
  const [userRole] = [...userRoles].filter(role => roles().includes(role));
  const indexOfUserRole = [...roles()].findIndex(role => role === userRole);

  return indexOfUserRole >= indexOfLeastRole;
}



// WEBPACK FOOTER //
// ./src/utils/roles.js